import { t } from './i18n';

// Petites notifications (toasts) sans dépendance : showToast('Message', 'success' | 'error' | 'info').
const CONTAINER_ID = 'tsk-toasts';

function getContainer() {
  let el = document.getElementById(CONTAINER_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = CONTAINER_ID;
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
  }
  return el;
}

export function showToast(message, type = 'success', duration = 3500) {
  const toast = document.createElement('div');
  toast.className = `tsk-toast tsk-toast--${type}`;
  const icon = document.createElement('span');
  icon.className = 'tsk-toast__icon';
  icon.textContent = type === 'error' ? '!' : type === 'info' ? 'i' : '✓';
  const text = document.createElement('span');
  text.textContent = message;
  toast.appendChild(icon);
  toast.appendChild(text);
  getContainer().appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('is-visible'));
  const remove = () => {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 250);
  };
  if (duration) setTimeout(remove, duration);
  return remove;
}

// « il y a 5 min », « 3 h ago »…
export function timeAgo(dateLike) {
  const time = new Date(dateLike).getTime();
  if (!time) return '';
  const s = Math.max(0, (Date.now() - time) / 1000);
  if (s < 60) return t('ui.time.now');
  if (s < 3600) return t('ui.time.min', { n: Math.floor(s / 60) });
  if (s < 86400) return t('ui.time.hour', { n: Math.floor(s / 3600) });
  return t('ui.time.day', { n: Math.floor(s / 86400) });
}
